import React from 'react';
import {PopoverMenuItemType} from "../../../core/gd-components/popover-menu/popover-menu/const";
import MoreProject_PopoverMenu from "../../../core/gd-ui/more/project/popover-menu";
import {ProjectsTreeSortType} from "../../../core/model2/space/@types";
import FormToggle from "../../../core/gd-form/form-element/toggle-new/toggle";
import menu_collapseAllProjects from "./collapse-all";
import menu_expandAllProjects from "./expand-all";
import menu_sectionMoveUp from "./section-move-up";
import menu_sectionMoveDown from "./section-move-down";
import {EVENT_BUS_MENU_RERENDER} from "../sections/const";
import Section from "../../../core/model2/project/section";
import NavigationMenu_ProjectsLocalSettings from "../local-settings";

export default function sectionPreferences_PopoverMenuOptions(section: Section, localSettings?: NavigationMenu_ProjectsLocalSettings, onReset?: callback) {


    const onCollapseAll = ()=> {
        menu_collapseAllProjects(section, localSettings)
    }

    const onExpandAll = ()=> {
        menu_expandAllProjects(section, localSettings)
    }

    const onMoveUp = () => {
        menu_sectionMoveUp(section)
    }

    const onMoveDown = () => {
        menu_sectionMoveDown(section)
    }

    const setManual = () => {
        section.projectsSorting = ProjectsTreeSortType.MANUAL_OLD

        gd.bus.triggerEvent(EVENT_BUS_MENU_RERENDER)
    }

    const setAlphabetical = () => {
        section.projectsSorting = ProjectsTreeSortType.ALPHABETICAL

        gd.bus.triggerEvent(EVENT_BUS_MENU_RERENDER)
    }

    const onSortDefaultReset = () => {
        section.resetSortedMap()
        onReset?.()
    }

    const onColorizeChange = (value:boolean) => {
        section.projectsColorize = value
        gd.bus.triggerEvent(EVENT_BUS_MENU_RERENDER)
    }

    let options: Option[] = []

    if (!gd.user.acl.isClient) {
        options = options.concat([
            {
                type            : PopoverMenuItemType.CUSTOM_POPOVER,
                icon            : 'i5-section',
                label           : 'Section Settings',
                menuComponent   : (params:any)=>{
                    return <MoreProject_PopoverMenu project        = {section.project}
                                                    hidePopover    = {params.menuParams.hidePopover}/>
                },
                popoverOffset   : "6 0"
            },
            {
                type: PopoverMenuItemType.SEPARATOR,
            },
        ])
    }

    options = options.concat([
        {
            icon        : 'i5-collapse',
            value       : true,
            label       : 'Collapse all',
            helpMessage : '',
            onClick     : onCollapseAll
        },
        {
            icon        : 'i5-expand',
            value       : false,
            label       : 'Expand all',
            helpMessage : '',
            onClick     : onExpandAll
        },
        {
            type        : PopoverMenuItemType.SEPARATOR,
        },

        {
            icon        : "i5-long-arrow-up",
            label       : "Move Up",
            onClick     : onMoveUp,
            disabled    : !section.previousSectionProject
        },
        {
            icon        : "i5-long-arrow-down",
            label       : "Move Down",
            onClick     : onMoveDown,
            disabled    : !section.nextSectionProject
        },

        {
            type        : PopoverMenuItemType.SEPARATOR,
        },

        {
            icon        : 'i5-az-sort',
            value       : ProjectsTreeSortType.ALPHABETICAL,
            label       : "A - Z",
            helpMessage : 'Order projects alphabetically',
            isSelected  : section.projectsSorting === ProjectsTreeSortType.ALPHABETICAL,
            onClick     : setAlphabetical
        },
        {
            icon        : 'i5-manual-sort',
            value       : ProjectsTreeSortType.MANUAL_OLD,
            label       : 'Manual',
            helpMessage : 'Drag and drop to reorder projects manually',
            isSelected  : section.projectsSorting === ProjectsTreeSortType.MANUAL_OLD,
            onClick     : setManual
        },
        {
            icon        : 'i5-reset',
            label       : "Reset manual sorting",
            onClick     : onSortDefaultReset,
            disabled    : section.projectsSorting === ProjectsTreeSortType.ALPHABETICAL || !section.isResetManualSortingAvailable,
            helpMessage : 'Reset sorting to default'
        },
        {
            type        : PopoverMenuItemType.SEPARATOR
        },
        {
            type        : PopoverMenuItemType.COMPONENT,
            component   : () => {
                return (
                    <div className="option fl-jsb">
                        <div className="label">Icon Color</div>
                        <FormToggle size="16" value={section.projectsColorize} onChange={onColorizeChange}/>
                    </div>
                )
            },
            helpMessage : 'Colorize project/folder icons'
        },
    ])

    return options

}
